module.exports = __webpack_public_path__ + "static/media/airBaloon.659c6736.png";